import { api } from "@/configs";
import { defineStore } from "pinia";
import { apiUrls } from "@/constants";
import Swal from "sweetalert2";
import { reloadDailyVerses } from "@/utils/dailyVerse";
import { notification } from "ant-design-vue";
import {reloadDevotions} from "@/utils/devotion";
import {devotionTypes} from "@/constants/enum";

export const useDailyVerseStore = defineStore("dailyVerse", {
    state: () => {
        return {
            copiedVerse: null,
            dailyVerses: [],
            monthlyVerses: {},
        };
    },
    getters: {
        /**
         *
         * @returns {Array}
         */
        loadDailyVersesByMonth: (state) => (year, month) => {
            const date = new Date(year, month).getTime();
            return state.monthlyVerses[date] ?? [];
        },
        findById: (state) => (dailyVerseId) => {
            const allDailyVerses = Object.values(state.monthlyVerses).flat();
            return allDailyVerses.find((data) => data.verse?.id === dailyVerseId);
        },
    },
    actions: {
        async addDailyVerse(
            bible = { bible_verse, thumbnail, curated_images, date, post_time }
        ) {
            try {
                await api.post(apiUrls.bible, bible, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                await reloadDailyVerses(bible.date);
                notification.success({ message: `Daily Verse Added` });
                return true;
            } catch (error) {
                return false;
            }
        },
        async updateDailyVerse(
            dailyVerseId,
            bible = { book, chapter, verse, thumbnail, curated_images, date, post_time }
        ) {
            try {
                await api.post(
                    `${apiUrls.bible}/${dailyVerseId}`,
                    { _method: "PATCH", ...bible },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                await reloadDailyVerses(bible.date);
                notification.success({ message: "Daily Verse Updated successfully" });
                return true;
            } catch (error) {
                return false;
            }
        },
        async fetchDailyVerses() {
            try {
                const response = await api.get(apiUrls.bible, {
                    params: { onlyRecent: true },
                });
                this.dailyVerses = response.data.data;
                return true;
            } catch (error) {
                return false;
            }
        },
        async deleteDailyVerse(id, bible = { date }) {
            try {
                const response = await api.delete(`${apiUrls.bible}/${id}`);
                await reloadDailyVerses(bible.date);
                return true;
            } catch (error) {
                return false;
            }
        },
        async fetchDailyVerseByMonth({ year, month }) {
            try {
                const params = {
                    year,
                    month: Number.parseInt(month) + 1,
                };
                const response = await api.get(apiUrls.bible, {
                    params: params,
                });

                // note: Timestamp of the Year and Month is used to Identify the devotion of a month from the
                const timestamp = new Date(year, month).getTime();
                this.monthlyVerses[timestamp] = response.data.data;
                return true;
            } catch (error) {
                return false;
            }
        },
        async fetchDailyVerseByDate(date) {
            try {
                const response = await api.get(`${apiUrls.bible}/${date}`, {
                    params: {
                        type,
                    },
                });
                return response.data.data;
            } catch (error) {
                log(error);
                return false;
            }
        },
        async deleteCuratedImage(id){
            try {
                const response = await api.delete(`${apiUrls.bible}/curated/images/${id}`);
                return response.data.data;
            } catch (error) {
                log(error);
                return false;
            }
        },
        // async fetchDevotionCategories(){
        //   try {
        //     const response = await api.get(apiUrls.categories, {
        //       params: { onlyRecent: true },
        //     });
        //     this.devotionCategories = response.data.data;
        //     return true;
        //   } catch (error) {
        //     return false;
        //   }
        // }
    },
});